module.exports = __webpack_public_path__ + "img/应用场景_干部培训.0bfec5c2.png";